import { render, staticRenderFns } from "./administrator.vue?vue&type=template&id=6ef6068e&scoped=true&"
import script from "./administrator.vue?vue&type=script&lang=js&"
export * from "./administrator.vue?vue&type=script&lang=js&"
import style0 from "./administrator.vue?vue&type=style&index=0&id=6ef6068e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6068e",
  null
  
)

export default component.exports